import React from "react";
import useDocumentTitle from "../hooks/useDocumentTitle";
import HeroSection from "../components/home/HeroSection";
import FeaturedWork from "../components/home/FeaturedWork";
import Testimonials from "../components/home/Testimonials";
import "./Home.css";
const Home = () => {
  useDocumentTitle("Home");
  return (
    <div className="home-page">
      <HeroSection />
      <FeaturedWork />
      <Testimonials />
    </div>
  );
};
export default Home;
